export default "__VITE_ASSET__CubZ_Emr__"